function getPath (element = {}) {
  const path = []

  if (element.style === undefined) return path

  path.push(element)

  while (element.parentNode) {
    path.push(element.parentNode)
    element = element.parentNode
  }

  path.push(window)

  return path
}

export default {
  getPath
}
